import React from "react";
import { ToastContainer, toast } from "material-react-toastify";
import "material-react-toastify/dist/ReactToastify.css";
import * as Sentry from "@sentry/react";
import { promiseWrapper } from "./utils/json/helper";
import { StatesLgas } from "./utils/json/state";
import axios from "axios";
import moment from "moment";

export const convertPhoneToISO = (number: string, countryCode: string) => {
  if (number.substring(0, 4) === `+${countryCode}`) {
    return number;
  } else if (number.substring(0, 3) === countryCode) {
    return `+${number}`;
  } else if (number.charAt(0) === "0") {
    return `+${countryCode}${number.slice(1)}`;
  } else {
    return null;
  }
};

const getReference = () => {
  let text = "";
  let sub = "";
  let possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-.=";

  for (let i = 0; i < 6; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  for (let i = 0; i < 6; i++) {
    sub += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return `AJOCARD-${text}-INS-Image-${sub}`;
};

type FamilyType = {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  sex: string;
  dob: string;
  maritalStatus: string;
  stateOfResidence: string;
  homeAddress: string;
  passport: string;
};

function ImageUpload ({data, baseAPIUrl, setData} : {data: any; baseAPIUrl: any; setData: (i: any) => void;}) {
  const [Image, setImage] = React.useState<string>("");
  const [uploading, setUploading] = React.useState(false);
  const uploadFile = (type: string) => (event: any) => {
    setUploading(true);
    if (event.target.files.length === 0) return;
    const media = event.target.files[0];
    const filename = media.name;
    const filesize = media.size / 1024 / 1024;
    let last_dot = filename.lastIndexOf(".");
    let ext = filename.slice(last_dot + 1);
    if (filesize > 20) {
      toast.error("Maximum image size should be 20MB");
      setUploading(false);
    } else if (
      ext !== "JPG" &&
      ext !== "jpg" &&
      ext !== "jpeg" &&
      ext !== "png"
    ) {
      toast.error("File extension should only be jpg, jpeg, or png");
      setUploading(false);
    } else {
      let bucketKey = `${getReference()}.${ext}`;
      let file = event.target.files[0];
      fetch(`${baseAPIUrl}/forms/upload/${bucketKey}?contentType=${ext}`)
        .then((response) => response.json())
        .then((result) => {
          var options = {
            headers: {
              "Content-Type": ext,
            },
          };
          axios
            .put(result.response.url, file, options)
            .then((result) => {
              setData({
                ...data,
                [type]: bucketKey,
              });

              const reader = new FileReader();
              reader.onload = (e: any) => {
                if (e.target.result) setImage(e.target.result);
              };
              reader.readAsDataURL(media);

              setUploading(false);
            })
            .catch((err) => {
              setUploading(false);
              console.log("err:", JSON.stringify(err));
              if (err?.message) {
                toast.error(err?.message || err?.errors[0].message);
              }
            });
        })
        .catch((err) => {
          setUploading(false);
          console.log("err", err);
          if (err?.message) {
            toast.error(err?.message || err?.errors[0].message);
          }
        });
    }
  };

  return (
    <>
      <label className="block  font-medium text-gray-700">
        <p className="text-xl font-medium mb-4">
          Upload your Passport Photograph
        </p>
      </label>
      {data && data.passport && Image && (
        <div className="image-preview">
          <img
            className="w-auto h-60 my-6"
            src={Image}
            alt=""
          />
        </div>
      )}
      <div className="mt-2 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
        <div className="space-y-1 text-center">
          <div className="flex text-sm text-center text-gray-600">
            <label
              htmlFor="passport"
              className="relative w-full cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
            >
              <span>
                {uploading ? "Uploading" : "Upload a"} file
              </span>
              <input
                required
                onChange={(e)=>{uploadFile("passport")(e);}}
                type="file"
                className="absolute top-0 right-0 left-0 opacity-0"
                style={{width: 200, zIndex: 99}}
              />
            </label>
          </div>
          <p className="text-xs text-gray-500">
            PNG, JPG, GIF up to 10MB
          </p>
        </div>
      </div>
    </>
  )
}

function FamilyForm({
  item,
  index,
  handleFamily,
  setFamily_members,
}: {
  item: any;
  index: any;
  handleFamily?: any;
  setFamily_members?: any;
}) {
  const baseAPIUrl = process.env.REACT_APP_FORM_API_URL;
  const state = StatesLgas.map((state: any) => {
    return {
      value: state["state"].name,
      label: state["state"].name,
    };
  });
  const [data, setDate] = React.useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    sex: "",
    dob: "",
    maritalStatus: "",
    stateOfResidence: "",
    homeAddress: "",
    passport: "",
  });
  const handleChange = (index: number) => ({
    target: { name, value },
  }: {
    target: { name: string; value: string };
  }) => {
    if(name.includes("maritalStatus")){
      setDate((data) => ({ ...data, maritalStatus: value }));
      const updateFamily = item;
      updateFamily[index] = { ...data, maritalStatus: value };
      handleFamily(updateFamily);
      return;
    } else if (name.includes("sex")){
      setDate((data) => ({ ...data, sex: value }));
      const updateFamily = item;
      updateFamily[index] = { ...data, sex: value };
      handleFamily(updateFamily);
      return;
    } else if (name.includes("dob")){
      let a = moment(value).toISOString();
      setDate((data) => ({ ...data, dob: a }));
      const updateFamily = item;
      updateFamily[index] = { ...data, dob: a };
      handleFamily(updateFamily);
      return;
    }
    setDate((data) => ({ ...data, [name]: value }));
    const updateFamily = item;
    updateFamily[index] = { ...data, [name]: value };
    handleFamily(updateFamily);
  };
  return (
    <div className="grid gap-9">
      <br />
      <div className="col-span-10">
        <hr />
        <br />
        <div className="flex items-center">
          <h3 className="text-xl font-semibold">Family Member {index + 1}</h3>
          <button
            className="py-3 px-5 mx-auto flex items-center justify-center rounded-md bg-red-500 border border-red-500 text-white"
            type="button"
            style={{fontSize: 12, padding: 8}}
            onClick={() => {
              const updateFamily = item.filter((fam: any, ind: any) => ind !== index)
              setFamily_members(updateFamily);
            }}
          >
            Delete Family Member
          </button>
        </div>
      </div>
      <div className="col-span-10">
        <label htmlFor="firstName" className="block font-bold text-gray-700">
          <p className="text-xl font-medium mb-4">First name</p>
          <input
            required
            onChange={handleChange(index)}
            value={data.firstName}
            type="text"
            name="firstName"
            id={"firstName" + index}
            autoComplete="given-name"
            className="mt-0 block w-full px-0.5 mt-5 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
          />
        </label>
      </div>
      <div className="col-span-10">
        <label htmlFor="lastName" className="block  font-bold text-gray-700">
          <p className="text-xl font-medium mb-4">
            Last Name/Surname/Family Name
          </p>
          <input
            required
            onChange={handleChange(index)}
            value={data.lastName}
            type="text"
            name="lastName"
            id={"lastName" + index}
            autoComplete="family-name"
            className="mt-0 block w-full px-0.5 mt-5 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
          />
        </label>
      </div>
      <div className="col-span-10 md:col-span-5">
        <label htmlFor="DOB" className="block">
          <p className="text-xl font-medium mb-4">Date of Birth</p>
          <input
            required
            onChange={handleChange(index)}
            value={data.dob?.split("T")[0]}
            name="dob"
            id={"dob" + index}
            autoComplete="dob"
            placeholder="click here to enter your date of birth"
            type="date"
            className="mt-0 block w-full md:w-3/5 px-0.5 mt-5 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
          />
        </label>
      </div>
      <div className="col-span-10 md:col-span-5">
        <label htmlFor="sex" className="block  font-bold text-gray-700">
          <p className="text-xl font-medium mb-4">Gender</p>
          <input
            type="radio"
            id={"sex1" + index}
            name={"sex" + index}
            onChange={handleChange(index)}
            defaultValue={"male"}
            required
            checked={data.sex === "male"}
          />
          &emsp;
          <label htmlFor="sex1">Male</label>
          <br />
          <input
            type="radio"
            id={"sex2" + index}
            name={"sex" + index}
            onChange={handleChange(index)}
            defaultValue={"female"}
            required
            checked={data.sex === "female"}
          />
          &emsp;
          <label htmlFor="sex2">Female</label>
          <br />
        </label>
      </div>
      <div className="col-span-10 md:col-span-5">
        <label
          htmlFor="phoneNumber"
          className="block  font-bold text-gray-700"
        >
          <p className="text-xl font-medium mb-4">Phone Number</p>
          <input
            required
            onChange={handleChange(index)}
            value={data.phoneNumber}
            type="tel"
            name="phoneNumber"
            id={"phoneNumber" + index}
            autoComplete="phone-number"
            className="mt-0 block w-full px-0.5 mt-5 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
          />
        </label>
      </div>
      <div className="col-span-10 md:col-span-5">
        <label
          htmlFor="email"
          className="block  font-bold text-gray-700"
        >
          <p className="text-xl font-medium mb-4">E-mail Address</p>
          <input
            required
            onChange={handleChange(index)}
            value={data.email}
            type="email"
            name="email"
            id={"email" + index}
            autoComplete="email"
            className="mt-0 block w-full px-0.5 mt-5 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
          />
        </label>
      </div>
      <div className="col-span-10">
        <label
          htmlFor="maritalStatus"
          className="block  font-bold text-gray-700"
        >
          <p className="text-xl font-medium mb-4">Marital Status</p>
          <input
            type="radio"
            id={"maritalStatus1" + index}
            name={"maritalStatus" + index}
            onChange={handleChange(index)}
            required
            defaultValue={"single"}
            checked={data.maritalStatus === "single"}
          />
          &emsp;
          <label htmlFor="maritalStatus1">Single</label>
          <br />
          <input
            type="radio"
            id={"maritalStatus2" + index}
            name={"maritalStatus" + index}
            required
            onChange={handleChange(index)}
            defaultValue={"married"}
            checked={data.maritalStatus === "married"}
          />
          &emsp;
          <label htmlFor="maritalStatus2">Married</label>
          <br />
          <input
            type="radio"
            id={"maritalStatus3" + index}
            name={"maritalStatus" + index}
            required
            onChange={handleChange(index)}
            defaultValue={"divorced"}
            checked={data.maritalStatus === "divorced"}
          />
          &emsp;
          <label htmlFor="maritalStatus3">Divorced</label>
          <br />
          <input
            type="radio"
            id={"maritalStatus4" + index}
            name={"maritalStatus" + index}
            onChange={handleChange(index)}
            required
            defaultValue={"widowed"}
            checked={data.maritalStatus === "widowed"}
          />
          &emsp;
          <label htmlFor="maritalStatus4">Widowed</label>
          <br />
        </label>
      </div>
      <div className="col-span-10 md:col-span-5">
        <label
          htmlFor="homeAddress"
          className="block  font-medium text-gray-700"
        >
          <p className="text-xl font-medium mb-4">Home address</p>
        </label>
        <textarea
          required
          onChange={handleChange(index)}
          value={data.homeAddress}
          rows={8}
          name="homeAddress"
          id={"homeAddress" + index}
          autoComplete="home-address"
          className="mt-0 block w-full px-0.5 mt-5 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
        />
      </div>
      <div className="col-span-10 md:col-span-5">
        <label
          htmlFor="stateOfResidence"
          className="block  font-bold text-gray-700"
        >
          <p className="text-xl font-medium mb-4">State of Residence</p>
          <select
            required
            onChange={handleChange(index)}
            value={data.stateOfResidence}
            id={"stateOfResidence" + index}
            name="stateOfResidence"
            autoComplete="stateOfResidence"
            className="block w-full mt-0 px-0.5 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
          >
            <option value="">Select State of Residence</option>
            {state.map((item: { value: string; label: string }) => (
              <option key={item.label} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </label>
      </div>
      <div className="col-span-9">
        <ImageUpload data={data} baseAPIUrl={baseAPIUrl} setData={(i: any) => {
          setDate(i)
          const updateFamily = item;
          updateFamily[index] = { ...data, passport: i.passport };
          handleFamily(updateFamily);
        }} />
      </div>
    </div>
  );
}

const App: React.FC<{}> = () => {
  const monnifyApiKey = process.env.REACT_APP_MONNIFY_API_KEY; // Monnify API key
  const monnifyContractCode = process.env.REACT_APP_MONNIFY_CONTRACT_CODE; // Monnify contract code
  const baseAPIUrl = process.env.REACT_APP_FORM_API_URL;
  const state = StatesLgas.map((state: any) => {
    return {
      value: state["state"].name,
      label: state["state"].name,
    };
  });
  const [data, setDate] = React.useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    sex: "",
    dob: "",
    maritalStatus: "",
    stateOfResidence: "",
    homeAddress: "",
    passport: "",
    healthPlan: "",
    amount: 0,
  });

  const initialStateFamily = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    sex: "",
    dob: "",
    maritalStatus: "",
    stateOfResidence: "",
    homeAddress: "",
    passport: "",
    healthPlan: data.healthPlan,
  };

  const [family_members, setFamily_members] = React.useState<FamilyType[]>([]);
  const [loading, setLoading] = React.useState(false);

  const successfulPayment = (response: any) => {
    const a = localStorage.getItem("keys") || "";
    let b: { ids?: string; updateKey?: string } = {};
    if (a) {
      b = JSON.parse(a);
    }
    const { ids, updateKey } = b;
    // console.log("njbkdhklk", updateKey, response, ids, b);
    toast.success("Successful Payment");
    fetch(`${baseAPIUrl}/forms/retail/${ids}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updateKey: updateKey || "",
        uniqueIdentifier: response.transactionReference,
      }),
    });
    setDate({
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: "",
      sex: "",
      dob: "",
      maritalStatus: "",
      stateOfResidence: "",
      homeAddress: "",
      passport: "",
      healthPlan: "",
      amount: 0,
    });
    setLoading(false);
    localStorage.clear();
  };

  const callback = (response: any) => {
    console.log("done");
    if (response && response.status && response.status === "SUCCESS") {
      successfulPayment(response);
    }
  };

  const close = (response: any) => {
    console.log("closed");
    setLoading(false);
    if (response && response.status && response.status === "SUCCESS") {
      setDate({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        sex: "",
        dob: "",
        maritalStatus: "",
        stateOfResidence: "",
        homeAddress: "",
        passport: "",
        healthPlan: "",
        amount: 0,
      });
      toast.success("Successful Update");
    }
  };

  const handleFamilyChange = (index: any) => ({
    target: { name, value },
  }: {
    target: { name: string; value: string };
  }) => {
    const newFamily: any = family_members;
    newFamily[index][name] = value;
    setFamily_members(newFamily);
  };

  const handleChange = ({
    target: { name, value },
  }: {
    target: { name: string; value: string };
  }) => {
    if (name.includes("dob")){
      let a = moment(value).toISOString();
      setDate((data) => ({ ...data, dob: a }));
      return;
    }
    setDate((data) => ({ ...data, [name]: value }));
    if (name === "healthPlan") {
      let amount = 0;
      if (value === "individual-12-month") {
        amount = 9120;
      } else if (value === "individual-3-month") {
        amount = 2400;
      } else if (value === "family-12-month") {
        amount = 36500;
      } else if (value === "family-3-month") {
        amount = 9200;
      }
      setDate((data) => ({ ...data, amount }));
    }
  };

  const monnifyPay = (ref: String) => {
    const paymentData = {
      amount: data.amount,
      currency: "NGN",
      customerFullName: `${data.lastName} ${data.firstName}`,
      customerEmail: data.email,
      customerMobileNumber: data.phoneNumber,
      apiKey: monnifyApiKey,
      contractCode: monnifyContractCode,
      paymentDescription: "AjoCard Health Insurance",
      metadata: {
        app: "ajocardhmoinsuranceplatform",
        app_data: JSON.stringify({
          ...data,
          phoneNumber: convertPhoneToISO(data.phoneNumber, "234"),
        }),
        type: "retail-form",
        typeID: ref,
      },
      reference: `AJOC-INS-${ref}`,
      isTestMode: false,
      paymentMethods: ["CARD"],
      onClose: close,
      onComplete: callback,
    };
    // @ts-ignore
    window.MonnifySDK.initialize(paymentData);
  };

  const initializePayment = async (e?: any) => {
    setLoading(true);
    if (e) {
      e.preventDefault();
    }

    let body = {
      firstName: data.firstName,
      lastName: data.lastName,
      phoneNumber: convertPhoneToISO(data.phoneNumber, "234"),
      email: data.email,
      sex: data.sex,
      dob: new Date(data.dob).toISOString(),
      maritalStatus: data.maritalStatus,
      stateOfResidence: data.stateOfResidence,
      homeAddress: data.homeAddress,
      passport: data.passport,
      healthPlan: data.healthPlan,
      amount: data.amount,
      familyMembers: family_members,
    };

    const [err, res]: Array<any> = await promiseWrapper(
      fetch(`${baseAPIUrl}/forms/retail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
    );

    if (!err && res.response && res.response.id) {
      localStorage.setItem(
        "keys",
        JSON.stringify({
          ids: res.response.id,
          updateKey: res.response.updateKey,
        })
      );
      monnifyPay(res.response.id);
    } else {
      setLoading(false);
      if (err?.message) {
        toast.error(err?.message || err?.errors[0].message);
      }
    }
  };

  const MonnifyButton = () => {
    return (
      <div className="px-4 py-3 text-right flex justify-center sm:px-6">
        <button
          // onClick={initializePayment}
          disabled={
            !data.healthPlan ||
            !data.dob ||
            !data.email ||
            !data.passport ||
            !data.firstName ||
            !data.homeAddress ||
            !data.amount ||
            !data.lastName ||
            !data.maritalStatus ||
            !data.phoneNumber ||
            !data.sex ||
            !data.stateOfResidence
          }
          type="submit"
          className="inline-flex justify-center text-black font-light py-2 text-sm md:text-xl px-20 border border-transparent shadow-md text-sm font-medium rounded-md bg-yellow-400 hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
        >
          {`Proceed to Pay (${data.amount.toLocaleString("en-NG", {
            currency: "NGN",
            style: "currency",
          })})`}
        </button>
      </div>
    );
  };

  return (
    <div className="mx-auto container">
      <header className="fixed w-100 left-0 right-0 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex justify-between items-center py-6 md:justify-start md:space-x-10">
            <div className="flex justify-start lg:w-0 lg:flex-1">
              <a href="/#">
                <span className="sr-only">AjoCard</span>
                <img
                  className="h-8 w-auto sm:h-10"
                  src="https://static.wixstatic.com/media/e050aa_bc6cf3b8a8674f9f89b95ef7de98b18a~mv2.png/v1/fill/w_406,h_176,al_c,q_85,usm_0.66_1.00_0.01/ajocard_logo_color_CROPPED.webp"
                  alt="ajocard"
                />
              </a>
            </div>
            <nav className="flex space-x-5">
              <a
                href="https://www.ajocard.com"
                style={{ fontSize: "0.7rem" }}
                className="text-base font-medium text-gray-500 hover:text-gray-900"
              >
                Home
              </a>
              <a
                href="https://www.ajocard.com/agents-learn-more"
                style={{ fontSize: "0.7rem" }}
                className="text-base font-medium text-gray-500 hover:text-gray-900"
              >
                Agents
              </a>
              <a
                href="https://www.ajocard.com/consumer"
                style={{ fontSize: "0.7rem" }}
                className="text-base font-medium text-gray-500 hover:text-gray-900"
              >
                Consumer
              </a>
              <a
                href="https://www.ajocard.com/hmo"
                style={{ fontSize: "0.7rem" }}
                className="text-base font-medium text-gray-500 hover:text-gray-900 hidden md:flex"
              >
                Health Insurance
              </a>
              <a
                href="https://www.ajocard.com/about"
                style={{ fontSize: "0.7rem" }}
                className="text-base font-medium text-gray-500 hover:text-gray-900"
              >
                About
              </a>
              <a
                href="https://www.ajocard.com/faq"
                style={{ fontSize: "0.7rem" }}
                className="text-base font-medium text-gray-500 hover:text-gray-900 hidden md:flex"
              >
                FAQ
              </a>
              <a
                href="https://www.ajocard.com/contact"
                style={{ fontSize: "0.7rem" }}
                className="text-base font-medium text-gray-500 hover:text-gray-900 hidden md:flex"
              >
                Contact
              </a>
            </nav>
            <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
              <a
                href="https://www.linkedin.com/company/ajocard"
                className="whitespace-nowrap text-base font-medium text-gray-500 hover:text-gray-900"
              >
                <img
                  alt="LinkedIn - Black Circle"
                  src="https://static.wixstatic.com/media/aa0402eb9ba2430d9d0620b59556efca.png/v1/fill/w_50,h_50,al_c,q_85,usm_0.66_1.00_0.01/aa0402eb9ba2430d9d0620b59556efca.webp"
                  style={{ width: 25, height: 25, objectFit: "cover" }}
                />
              </a>
              <a
                href="http://www.facebook.com/ajocard1"
                className="whitespace-nowrap text-base font-medium text-gray-500 hover:text-gray-900"
              >
                <img
                  alt="Black Facebook Icon"
                  src="https://static.wixstatic.com/media/0fdef751204647a3bbd7eaa2827ed4f9.png/v1/fill/w_50,h_50,al_c,q_85,usm_0.66_1.00_0.01/0fdef751204647a3bbd7eaa2827ed4f9.webp"
                  style={{ width: 25, height: 25, objectFit: "cover" }}
                />
              </a>
              <a
                href="http://www.twitter.com/ajocard"
                className="whitespace-nowrap text-base font-medium text-gray-500 hover:text-gray-900"
              >
                <img
                  alt="Black Twitter Icon"
                  src="https://static.wixstatic.com/media/c7d035ba85f6486680c2facedecdcf4d.png/v1/fill/w_50,h_50,al_c,q_85,usm_0.66_1.00_0.01/c7d035ba85f6486680c2facedecdcf4d.webp"
                  style={{ width: 25, height: 25, objectFit: "cover" }}
                />
              </a>
              <a
                href="https://instagram.com/ajocard"
                className="whitespace-nowrap text-base font-medium text-gray-500 hover:text-gray-900"
              >
                <img
                  alt="Black Instagram Icon"
                  src="https://static.wixstatic.com/media/01c3aff52f2a4dffa526d7a9843d46ea.png/v1/fill/w_50,h_50,al_c,q_85,usm_0.66_1.00_0.01/01c3aff52f2a4dffa526d7a9843d46ea.webp"
                  style={{ width: 25, height: 25, objectFit: "cover" }}
                />
              </a>
            </div>
          </div>
        </div>
      </header>
      <main>
        <div className="bg-white">
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <div className="max-w-6xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-center overflow-hidden ">
            <div className="mt-10 sm:mt-0 lg:w-4/5 sm:w-5/6 w-full">
              <form onSubmit={(e) => initializePayment(e)}>
                <div className="py-5 bg-white sm:p-6">
                  <h3 className="flex align-start flex-col text-xl font-semibold mb-16">
                    <span>Let's get you signed up for Health Insurance.</span>
                    <span>It takes only 3 minutes</span>
                  </h3>
                  <div className="grid gap-9">
                    <div className="col-span-12">
                      <label
                        htmlFor="healthPlan"
                        className="block  font-bold text-gray-700"
                        style={{ width: 334, fontSize: 14 }}
                      >
                        <h2 className="text-xl mb-4">Select a Payment Plan</h2>
                        <h3 className="text-xl mb-2">
                          <small>Individual Plan</small>
                        </h3>
                        <input
                          type="radio"
                          id="healthPlan1"
                          name="healthPlan"
                          onChange={handleChange}
                          checked={data.healthPlan === "individual-12-month"}
                          defaultValue={"individual-12-month"}
                        />
                        &emsp;
                        <label htmlFor="healthPlan1">
                          1 year (₦̶9̶,̶6̶0̶0̶ ₦9,120) - Most Popular
                        </label>
                        <br />
                        <input
                          type="radio"
                          id="healthPlan2"
                          name="healthPlan"
                          onChange={handleChange}
                          checked={data.healthPlan === "individual-3-month"}
                          defaultValue={"individual-3-month"}
                        />
                        &emsp;
                        <label htmlFor="healthPlan2">3 Months (₦2,400)</label>
                        <br />
                        <br />
                        <h3 className="text-xl mb-2">
                          <small>Family Plan</small>
                        </h3>
                        <input
                          type="radio"
                          id="healthPlan1"
                          name="healthPlan"
                          onChange={handleChange}
                          checked={data.healthPlan === "family-12-month"}
                          defaultValue={"family-12-month"}
                        />
                        &emsp;
                        <label htmlFor="healthPlan1">1 year (₦36,500)</label>
                        <br />
                        <input
                          type="radio"
                          id="healthPlan2"
                          name="healthPlan"
                          onChange={handleChange}
                          checked={data.healthPlan === "family-3-month"}
                          defaultValue={"family-3-month"}
                        />
                        &emsp;
                        <label htmlFor="healthPlan2">3 Months (₦9,200)</label>
                        <br />
                      </label>
                    </div>
                  </div>
                  <br />
                  <br />
                  <div className="grid gap-9">
                    <div className="col-span-10">
                      <label
                        htmlFor="firstName"
                        className="block font-bold text-gray-700"
                      >
                        <p className="text-xl font-medium mb-4">First name</p>
                        <input
                          required
                          onChange={handleChange}
                          value={data.firstName}
                          type="text"
                          name="firstName"
                          id="firstName"
                          autoComplete="given-name"
                          className="mt-0 block w-full px-0.5 mt-5 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
                        />
                      </label>
                    </div>
                    <div className="col-span-10">
                      <label
                        htmlFor="lastName"
                        className="block  font-bold text-gray-700"
                      >
                        <p className="text-xl font-medium mb-4">
                          Last Name/Surname/Family Name
                        </p>
                        <input
                          required
                          onChange={handleChange}
                          value={data.lastName}
                          type="text"
                          name="lastName"
                          id="lastName"
                          autoComplete="family-name"
                          className="mt-0 block w-full px-0.5 mt-5 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
                        />
                      </label>
                    </div>
                    <div className="col-span-10 md:col-span-5">
                      <label htmlFor="DOB" className="block">
                        <p className="text-xl font-medium mb-4">
                          Date of Birth
                        </p>
                        <input
                          required
                          onChange={handleChange}
                          value={data.dob?.split("T")[0]}
                          name="dob"
                          id="dob"
                          autoComplete="dob"
                          placeholder="click here to enter your date of birth"
                          type="date"
                          className="mt-0 block w-full md:w-3/5 px-0.5 mt-5 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
                        />
                      </label>
                    </div>
                    <div className="col-span-10 md:col-span-5">
                      <label
                        htmlFor="sex"
                        className="block  font-bold text-gray-700"
                      >
                        <p className="text-xl font-medium mb-4">Gender</p>
                        <input
                          type="radio"
                          id="sex1"
                          name="sex"
                          onChange={handleChange}
                          defaultValue={"male"}
                          checked={data.sex === "male"}
                        />
                        &emsp;
                        <label htmlFor="sex1">Male</label>
                        <br />
                        <input
                          type="radio"
                          id="sex2"
                          name="sex"
                          onChange={handleChange}
                          defaultValue={"female"}
                          checked={data.sex === "female"}
                        />
                        &emsp;
                        <label htmlFor="sex2">Female</label>
                        <br />
                      </label>
                    </div>
                    <div className="col-span-10 md:col-span-5">
                      <label
                        htmlFor="phoneNumber"
                        className="block  font-bold text-gray-700"
                      >
                        <p className="text-xl font-medium mb-4">Phone Number</p>
                        <input
                          required
                          onChange={handleChange}
                          value={data.phoneNumber}
                          type="tel"
                          name="phoneNumber"
                          id="phoneNumber"
                          autoComplete="phone-number"
                          className="mt-0 block w-full px-0.5 mt-5 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
                        />
                      </label>
                    </div>
                    <div className="col-span-10 md:col-span-5">
                      <label
                        htmlFor="email"
                        className="block  font-bold text-gray-700"
                      >
                        <p className="text-xl font-medium mb-4">
                          E-mail Address
                        </p>
                        <input
                          required
                          onChange={handleChange}
                          value={data.email}
                          type="email"
                          name="email"
                          id="email"
                          autoComplete="email"
                          className="mt-0 block w-full px-0.5 mt-5 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
                        />
                      </label>
                    </div>

                    <div className="col-span-10">
                      <label
                        htmlFor="maritalStatus"
                        className="block  font-bold text-gray-700"
                      >
                        <p className="text-xl font-medium mb-4">
                          Marital Status
                        </p>
                        <input
                          type="radio"
                          id="maritalStatus1"
                          name="maritalStatus"
                          onChange={handleChange}
                          defaultValue={"single"}
                          checked={data.maritalStatus === "single"}
                        />
                        &emsp;
                        <label htmlFor="maritalStatus1">Single</label>
                        <br />
                        <input
                          type="radio"
                          id="maritalStatus2"
                          name="maritalStatus"
                          onChange={handleChange}
                          defaultValue={"married"}
                          checked={data.maritalStatus === "married"}
                        />
                        &emsp;
                        <label htmlFor="maritalStatus2">Married</label>
                        <br />
                        <input
                          type="radio"
                          id="maritalStatus3"
                          name="maritalStatus"
                          onChange={handleChange}
                          defaultValue={"divorced"}
                          checked={data.maritalStatus === "divorced"}
                        />
                        &emsp;
                        <label htmlFor="maritalStatus3">Divorced</label>
                        <br />
                        <input
                          type="radio"
                          id="maritalStatus4"
                          name="maritalStatus"
                          onChange={handleChange}
                          defaultValue={"widowed"}
                          checked={data.maritalStatus === "widowed"}
                        />
                        &emsp;
                        <label htmlFor="maritalStatus4">Widowed</label>
                        <br />
                      </label>
                    </div>
                    <div className="col-span-10 md:col-span-5">
                      <label
                        htmlFor="homeAddress"
                        className="block  font-medium text-gray-700"
                      >
                        <p className="text-xl font-medium mb-4">Home address</p>
                      </label>
                      <textarea
                        required
                        onChange={handleChange}
                        value={data.homeAddress}
                        rows={8}
                        name="homeAddress"
                        id="homeAddress"
                        autoComplete="home-address"
                        className="mt-0 block w-full px-0.5 mt-5 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
                      />
                    </div>
                    <div className="col-span-10 md:col-span-5">
                      <label
                        htmlFor="stateOfResidence"
                        className="block  font-bold text-gray-700"
                      >
                        <p className="text-xl font-medium mb-4">
                          State of Residence
                        </p>
                        <select
                          required
                          onChange={handleChange}
                          value={data.stateOfResidence}
                          id="stateOfResidence"
                          name="stateOfResidence"
                          autoComplete="stateOfResidence"
                          className="block w-full mt-0 px-0.5 border-b-2 border-gray-200 focus:ring-0 focus:border-black"
                        >
                          <option value="">Select State of Residence</option>
                          {state.map(
                            (item: { value: string; label: string }) => (
                              <option key={item.label} value={item.value}>
                                {item.label}
                              </option>
                            )
                          )}
                        </select>
                      </label>
                    </div>
                    <div className="col-span-9">
                      <ImageUpload data={data} baseAPIUrl={baseAPIUrl} setData={(i: any) => setDate(i)} />
                    </div>
                  </div>
                  {data?.healthPlan?.toLowerCase()?.includes("family") &&
                    family_members &&
                    family_members?.map((item: any, index: any) => (
                      <FamilyForm
                        item={family_members}
                        index={index}
                        handleFamily={handleFamilyChange}
                        setFamily_members={setFamily_members}
                        key={index}
                      />
                    ))}
                  {data?.healthPlan?.toLowerCase()?.includes("family") &&
                    family_members.length < 3 && (
                      <div className="col-span-9">
                        <br />
                        <button
                          className="py-3 px-5 mx-auto flex items-center justify-center rounded-md border border-gray-500"
                          type="button"
                          onClick={() => {
                            setFamily_members([
                              ...family_members,
                              { ...initialStateFamily },
                            ]);
                          }}
                        >
                          Add Family Member
                        </button>
                      </div>
                    )}
                </div>
                {!loading ? <MonnifyButton /> : "Loading......."}
              </form>
            </div>
          </div>
        </div>
      </main>
      <footer>
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 flex items-center justify-between">
          <span>
            © 2021 AjoCard Limited. 983A Saka Jojo Street, Victoria Island,
            Lagos, Nigeria
          </span>
          <nav className="flex space-x-5">
            <a
              href="https://www.ajocard.com/privacy"
              style={{ textDecoration: "underline" }}
              className="text-base font-medium text-gray-500 hover:text-gray-900"
            >
              Privacy
            </a>{" "}
            -{" "}
            <a
              href="https://www.ajocard.com/terms"
              style={{ textDecoration: "underline" }}
              className="text-base font-medium text-gray-500 hover:text-gray-900"
            >
              Terms
            </a>
          </nav>
        </div>
      </footer>
    </div>
  );
};

export default Sentry.withErrorBoundary(App, {
  fallback: "an error has occurred",
});
